/* Translation lookup for the browser-side strings.
 *
 * The Jinja templates get their text from gettext at render time; the strings
 * that live in js -- toast messages, the sentences describe-alert.js builds,
 * chart labels -- have no render step to hook, so the server ships them as a
 * dict in window.I18N (see templates/partials/_i18n.html) and this file reads
 * it.  Same gettext catalog on both sides: the partial calls _() per key, so
 * pybabel extracts them with everything else and there is no second glossary
 * to keep in sync.
 *
 * boot/base.js imports this before format.js and describe-alert.js -- both of
 * those call t() while Alpine is doing its first render, and a global that
 * appears later is not a reactive dependency Alpine would re-render for.
 * window.I18N itself is an inline script in the template (Jinja-rendered).
 */
(function (w) {
  'use strict';

  var CATALOG = w.I18N || {};

  /* Interpolate {name} placeholders.
   *
   * Whole sentences are translated, never fragments glued together, because
   * Turkish puts the verb last and inflects the noun it attaches to: the
   * English order "RSI crosses above 70" has to become "RSI 70 seviyesini
   * yukari keserse", which no amount of translating "crosses"+"above"
   * separately can produce.  So a key names a complete sentence and the
   * translator is free to move the placeholders around inside it.
   */
  function interpolate(template, vars) {
    if (!vars) return template;
    return template.replace(/\{(\w+)\}/g, function (match, name) {
      return Object.prototype.hasOwnProperty.call(vars, name)
        ? String(vars[name])
        : match;   /* leave an unknown placeholder visible rather than blank,
                      so a typo in a .po file shows up instead of vanishing */
    });
  }

  /* t('key', {vars}) -> translated string.
   *
   * A missing key falls back to the key itself.  The keys are written as
   * readable English source text, so an untranslated string degrades to
   * English rather than to a debug token in a user's face.
   */
  w.t = function (key, vars) {
    var s = Object.prototype.hasOwnProperty.call(CATALOG, key) ? CATALOG[key] : key;
    return interpolate(s, vars);
  };

  w.t.has = function (key) {
    return Object.prototype.hasOwnProperty.call(CATALOG, key);
  };

  /* The active language, for the few places that need to branch on it --
   * Intl formatting in format.js above all.
   */
  w.t.locale = w.I18N_LOCALE || 'en';
})(window);

// Also reachable as window.t: Alpine's inline expressions can only see globals.
export const t = window.t;
